<form name="frmReports" style="margin-top:-1.5%;">
    <div class="container panel panel-default col-md-12" style="padding-left:0%;padding-right:0%;border-color:black;height:80vw;">
        <div>
            <div class="panel panel-heading" style="background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.2%; color: white;">Summary Reports</div>
            <div class="activity-box" *ngIf="loaderGif">
                <div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load" /></div>
            </div>
            <div class="panel-body">
                <div class="col-lg-12" style="padding-top:1%;">
                    <div class="form-group row">
                        <div class="col-sm-12 ">
                            <div class="col-sm-3 formdivcaptions">
                                <label for="dlstDeviceType">Device Type 
                                    <span _ngcontent-mfc-c156="" style="color: red;margin-left: 3px;">*</span>
                                </label>
                                <select class="form-control form-control-sm col-sm-4" id="dlstDeviceType" name="dlstDeviceType" [(ngModel)]="dlstDeviceType" (change)="DeviceTypeEvent()">                                   
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let D of DeviceTypeList" value="{{D.name}}">{{D.name}}</option>
                                </select>
                            </div>
                            <div class="col-sm-3 formdivcaptions">
                                <label for="dlstReportType">Report Type
                                    <span _ngcontent-mfc-c156="" style="color: red;margin-left: 3px;">*</span>
                                </label>
                                <select class="form-control form-control-sm col-sm-4" id="dlstReportType" name="dlstReportType" [(ngModel)]="dlstReportType" (change)="ReportAction()">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let ReportType of ReportTypes" value="{{ReportType.Value}}">{{ReportType.Value}}</option>
                                </select>
                            </div>
                            <div class="col-sm-3 formdivcaptions">
                                <label for="InitiatedDate">Schedule Date<span _ngcontent-mfc-c156="" style="color: red;margin-left: 3px;">*</span></label>

                                <input type="text" matInput [min]="minDate" name="InitiatedDate" readonly="true" style="background-color: white;" class="form-control form-control-sm" id="InitiatedDate" [(ngModel)]="Reports.ScheduledDate" [matDatepicker]="InitiatedDate" (focus)="showPicker()"
                                />
                                <mat-datepicker #InitiatedDate></mat-datepicker>
                            </div>
                            <div class="col-sm-3 formdivcaptions">
                                <label for="dlstFrequencyType">Schedule Frequency 
                                    <span _ngcontent-mfc-c156="" style="color: red;margin-left: 3px;">*</span>
                                </label>
                                <select class="form-control form-control-sm col-sm-4" id="dlstFrequencyType" name="dlstFrequencyType" [(ngModel)]="Reports.FrequencyType" (change)="FrequencyTypeEvent()">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let D of FrequencyTypeList" value="{{D.name}}">{{D.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-3 formdivcaptions" id="divCountry" style="margin-top:1%;">
                                <label>Country
                                <span _ngcontent-mfc-c156="" style="color: red;margin-left: 3px;">*</span>
                                </label>
                                <!-- <ejs-dropdownlist #CountryList class="form-control form-control-sm col-sm-4 " id="dlstCountry" [dataSource]='Countries' (change)="GetFacility()" [fields]='CountryFields' placeholder='&lt;--Select--&gt;' Value="&lt;--Select--&gt;">
                                    <ng-template #noRecordsTemplate>
                                        <span>No data available</span>
                                    </ng-template>
                                </ejs-dropdownlist> -->
                                <select  class="form-control form-control-sm col-sm-4" id="dlstCountry" [(ngModel)]="CountryList" (change)="GetFacility()">
                                    <option value="" disabled selected>&lt;--Select--&gt;</option>
                                    <option *ngFor="let country of Countries" [value]="country.Country">{{ country.Country }}</option>
                                  </select>
                            </div>
                            <div class="col-sm-3 formdivcaptions" id="divLocation" style="margin-top:1%;">
                                <label for="txtEmailTo">EmailTo<span _ngcontent-mfc-c156="" style="color: red;margin-left: 3px;">*</span></label>
                                <input type="text" id="txtEmailTo" name="txtEmailTo" [(ngModel)]="Reports.EmailTo" class="form-control" (change)="GreyCallee()" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button type="button" style="margin-top: 50px;" id="btnSend" class="btn btn-default btn-group-sm" (click)="Send()"><span class="glyphicon" aria-hidden="true"></span> Send</button>
                </div>
                <br />

            </div>
            <br/>
        </div>

        <div class="row" id="divSumReportDetails" *ngIf="GridSumflag">
            <div style="margin-left: 20px; margin-right: 20px;">
                <table id="SummaryReportDetails" class="table table-bordered" border="1" style="margin-left:2.7%;width:95%;font-size:13px;">
                    <thead style="color:white;background: #8064A2; background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                        <tr>
                            <th style="display:none">S.No</th>
                            <th style="text-align: center;width:7%;"></th>
                            <th style="text-align: center;width:20%;">Report Type</th>
                            <th style="text-align: center;width:20%;">Schedule Date</th>
                            <th style="text-align: center;width:17%;">Schedule Frequency</th>
                            <th style="text-align: center;width:20%;">Country</th>
                            <th style="text-align: center;width:20%;">Email To</th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let SumReport of successfulData.SummaryReport">
                        <tr *ngIf="SumReport.SchedulerId != this.successfulData.selected.SchedulerId">
                            <td>
                                <img src="assets/img/Edit-icon.png" title="Edit" (click)="EditReport(SumReport)" />
                                <img src="assets/img/Delete.png" title="Delete" (click)="DeleteReport(SumReport)" />
                            </td>
                            <td style="display:none;">{{SumReport.SchedulerId}}</td>
                            <td>{{SumReport.Report}}</td>
                            <td>{{SumReport.ScheduleDate}}</td>
                            <td>{{SumReport.ScheduleFrequency}}</td>
                            <td>{{SumReport.Country}}</td>
                            <td>{{SumReport.EmailTo}}</td>
                        </tr>
                        <tr *ngIf="SumReport.SchedulerId === this.successfulData.selected.SchedulerId">
                            <td>
                                <img src="assets/img/Add.png" (click)="ReportUpdate(SumReport)" title="Update" />
                                <img src="assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />
                            </td>
                            <td style="display:none;">{{successfulData.selected.SchedulerId}}</td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select [(ngModel)]="successfulData.selected.Report" id="grdSumReportType" name="grdSumReportType" class="form-control">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let R of ReportTypes" [ngValue]="R.Value">{{R.Value}}</option>        
                                </select>
                            </td>
                            <td>
                                <div class="col-sm-3 formdivcaptions">
                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                        <span>*</span>
                                    </div>
                                    <input type="text" matInput [min]="minDate" name="RInitiatedDate" readonly="true" style="background-color: white;width:100px" class="form-control form-control-sm" id="RInitiatedDate" [(ngModel)]="successfulData.selected.ScheduleDate" [matDatepicker]="RInitiatedDate"
                                        (focus)="RshowPicker()" />
                                    <mat-datepicker #RInitiatedDate></mat-datepicker>
                                </div>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select [(ngModel)]="successfulData.selected.ScheduleFrequency" id="grdSumScheduleFrequency" name="grdSumScheduleFrequency" class="form-control">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let F of FrequencyTypeList" [ngValue]="F.name">{{F.name}}</option>        
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <select [(ngModel)]="successfulData.selected.Country" id="grdSumCountry" name="grdSumCountry" class="form-control ">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let C of Countries" [ngValue]="C.Country">{{C.Country}}</option>        
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-1.3%;margin-top:2%;" class="col-md-1">
                                    <span>*</span>
                                </div>
                                <input type="text" class="form-control" [(ngModel)]="successfulData.selected.EmailTo" maxlength="1000" id="grdSumEmailTo" name="grdSumEmailTo" />
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="11" style="text-align: center;">
                                <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                        </a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                    </li>
                                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                        <a (click)="setPage(page)">{{page}}</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                        <a (click)="setPage(pager.startPage + 5)">...</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5">
                                        <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                    </li>

                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>

</form>